module.exports = __webpack_public_path__ + "img/oauth-error.18b28aec.jpg";